/* eslint react-hooks/exhaustive-deps: "warn" */
import cn from 'classnames';

import styles from './AnimatedDotsBackground.module.scss';

type LineConfig = {
  dir: 'right' | 'left';
  dots: number;
};

const LINES_4: LineConfig[] = [
  { dir: 'right', dots: 5 },
  { dir: 'left', dots: 7 },
  { dir: 'right', dots: 8 },
  { dir: 'left', dots: 6 },
];

const LINES_2: LineConfig[] = [
  { dir: 'right', dots: 5 },
  { dir: 'left', dots: 6 },
];

const renderDots = (count: number) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <span key={`a-${i}`} className={styles.dot}></span>
    ))}
    {Array.from({ length: count }).map((_, i) => (
      <span key={`b-${i}`} className={styles.dot}></span>
    ))}
  </>
);

type Props = {
  lines?: 2 | 4;
  opacity?: number;
  paddingY?: number;
  offsetY?: number;
  gap?: number;
  className?: string;
};

export const AnimatedDotsBackground = ({
  lines = 4,
  opacity = 1,
  paddingY = 40,
  offsetY = 0,
  gap,
  className,
}: Props) => {
  const config = lines === 2 ? LINES_2 : LINES_4;

  const linesStyle: Record<string, string> = {};
  if (offsetY !== 0) linesStyle.transform = `translateY(${offsetY}px)`;
  if (gap !== undefined) linesStyle.gap = `${gap}px`;

  return (
    <div className={cn(styles.wrapper, className)} style={{ opacity, top: `-${paddingY}px`, bottom: `-${paddingY}px` }}>
      <div className={styles.lines} style={Object.keys(linesStyle).length ? linesStyle : undefined}>
        {config.map((line, i) => (
          <div key={i} className={cn(styles.line, styles[line.dir])}>
            <div className={styles.dots}>{renderDots(line.dots)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
